import { useEffect, useState } from "react";
import "../../features/modal.css";
import { Users } from "../../interfaces/UserInterface";
import { dataEncrypt } from "../../features/data-encrypt";
import { API_LOGIN } from "../../features/constants";
import { Alerta, Toast } from "../../features/toast";
import { dataDecrypt } from "../../features/data-decrypt";

interface userProps {
    id:String | undefined
}

export const UserUpdate = ({id}:userProps)=>{

    const [verFormLog, setVerFormLog] = useState(false);
    const [nombre, setNombre] = useState("");
    const [userEncrypted, setUserEncrypted] = useState("");
    const [pwdEncrypted, setPwdEncrypted] = useState("");
    const [user, setUser] = useState<Users>()

    const [showPass, setShowPass] = useState(false);
    const [showUser, setShowUser] = useState(false);

    useEffect(()=>{
        if(id){
            let init = {
                method: "POST",
                body: JSON.stringify({
                    Id: id
                }),
                header:{
                    "Content-Type":"aplication/json"
                }
            };

            fetch(API_LOGIN + "/User",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:Users[])=>{
                setUser(data[0]);
                if(data[0].Nombre)
                    setNombre(data[0].Nombre.toString());
            })
        }
    
    },[id])

    const guardar = ()=>{
        
        let init = {
            method: "PUT",
            body: JSON.stringify({
                User: userEncrypted,
                Password: pwdEncrypted,
                Nombre: nombre,
                Id: user?.Id
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };

        fetch(API_LOGIN + "/User",init)
            .then(respons=>respons.json())
            .catch((error:string)=>{
                console.log(error);
                Alerta.fire({
                    title:"Error al intentar acceder a la base de datos",
                    text: error.toString(),
                    icon: "error"
                })
            })
            .then((data)=>{
            if (data){
                if(data.Mensaje === "Ok"){
                    Toast.fire({
                        title: "Actualizació de Usuario",
                        text: "Usuario actualizado correctamente",
                        icon: "success"
                    })
                }else{
                    Toast.fire({
                        title: "Error",
                        text: "No se pudo actualizar el Usuario",
                        icon: "warning"
                    })
                }
            }else{
                Toast.fire({
                    title:"Error de Conexión",
                    text: "No se tiene acceso a la base de datos",
                    icon: "error"
                })
            }
            })
        setVerFormLog(false);
    }

    return(
        <>

            {
                verFormLog?
                    <div className="modal">
                        <div className="modal-content modal-size-4">
                            <div className="modal-header d-flex justify-content-between align-items-center">
                                <h5 className="modal-title">Información Personal</h5>
                                <div className="logo">Si.T.A.</div>
                            </div>
                            
                            <div className="modal-body">

                                <div className="mb-3">
                                    <label htmlFor="nombreText" className="form-label">Nombre</label>
                                    <input
                                        value={nombre}
                                        type="text"
                                        className="form-control"
                                        name="nombreText"
                                        id="nombreText"
                                        onChange={(e)=>setNombre(e.target.value)}
                                    />
                                </div>
                                
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Usuario</label>
                                    <div className="d-flex justify-content-center">
                                        <input
                                            id="userText"
                                            type={showUser?"text":"password"}
                                            className="form-control"
                                            onBlur={(e)=>setUserEncrypted(dataEncrypt(e.target.value))}
                                            placeholder="**********"
                                        />
                                        <button 
                                            className="btn btn-sm btn-light" 
                                            onClick={()=>setShowUser(!showUser)}
                                            title={showUser?"Ocultar Usuario":"Mostrar Usuario"}
                                        >
                                            <i className={showUser?"bi bi-eye-slash-fill":"bi bi-eye-fill"}></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Contraseña</label>
                                    <div className="d-flex justify-content-center">
                                        <input
                                            id="pwdText"
                                            type={showPass?"text":"password"}
                                            className="form-control"
                                            onKeyUp={(e)=>setPwdEncrypted(dataEncrypt(e.currentTarget.value))}
                                            placeholder="**********"
                                        />
                                        <button 
                                            className="btn btn-sm btn-light" 
                                            onClick={()=>setShowPass(!showPass)}
                                            title={showPass?"Ocultar Contraseña":"Mostrar Contraseña"}
                                        >
                                            <i className={showPass?"bi bi-eye-slash-fill":"bi bi-eye-fill"}></i>
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-outline-dark mx-2" onClick={()=>{setVerFormLog(false);setUserEncrypted("");setPwdEncrypted("")}} >Cancelar</button>
                                <button type="submit" className="btn btn-outline-success mx-2" onClick={guardar}>Guardar</button>
                                
                            </div>
                        </div>
                    </div>
                    :
                    <button className="btn btn-outline-primary btn-sm mx-2" onClick={()=>setVerFormLog(true)}><i className="bi bi-person-vcard-fill"></i></button>
                    
                
            }

        </>
    )
}